import React, { PureComponent } from "react";
import "./ChartOptionsSidebar.scss";

class ChartOptionsSidebar extends PureComponent {
    optionsSidebarRef = React.createRef();
    state = {};

    componentDidMount() {
        setTimeout(() => {
            document.body.addEventListener("click", this.closeOptionsSidebar);
            const divs = document.querySelectorAll(".ui.dropdown");
            divs.forEach((el) => el.addEventListener("click", this.closeOptionsSidebar));
        }, 100);
    }

    componentWillUnmount() {
        document.body.removeEventListener("click", this.closeOptionsSidebar);
        const divs = document.querySelectorAll(".ui.dropdown");
        divs.forEach((el) => el.removeEventListener("click", this.closeOptionsSidebar));
    }

    closeOptionsSidebar = (e) => {
        let element = this.optionsSidebarRef.current;
        if (element && e.target !== element && !element.contains(e.target)) {
            this.props.changeShowMoreOptions();
        }
    };

    render() {
        let childrenPresent = this.props.children && Array.isArray(this.props.children) ? this.props.children.some((c) => c !== false) : this.props.children;
        return (
            this.props.showMoreOptionsLoc &&
            childrenPresent && (
                <div
                    className={`chart-options-sidebar skiptranslate ${this.props.className ? this.props.className : ""}`}
                    id="chart-options-sidebar"
                    ref={this.optionsSidebarRef}
                    style={{ top: this.props.showMoreOptionsLoc.y, left: this.props.showMoreOptionsLoc.x, zIndex: "99999" }}>
                    <div className="chart-options-column">{this.props.children}</div>
                </div>
            )
        );
    }
}

export default ChartOptionsSidebar;
